import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=0c2396c2"
import script from "./ProductSelect.vue?vue&type=script&lang=js"
export * from "./ProductSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports